export function formatRuleTiming(delayMinutes, eventType) {
  if (delayMinutes === 0) return 'Immediate';

  const abs = Math.abs(delayMinutes);
  let timeStr;
  if (abs >= 1440 && abs % 1440 === 0) {
    const days = abs / 1440;
    timeStr = `${days}d`;
  } else if (abs >= 60 && abs % 60 === 0) {
    const hours = abs / 60;
    timeStr = `${hours}h`;
  } else {
    timeStr = `${abs}m`;
  }

  // Determine anchor label from eventType
  let anchor = 'event';
  if (eventType.startsWith('checkin_minus') || eventType === 'reservation_approved') {
    anchor = 'check-in';
  } else if (eventType.startsWith('checkout_minus')) {
    anchor = 'check-out';
  } else if (eventType.startsWith('payment_due_minus')) {
    anchor = 'payment due';
  } else if (eventType === 'reservation_created') {
    anchor = 'booking';
  }

  if (delayMinutes < 0) {
    return `${timeStr} before ${anchor}`;
  }
  return `${timeStr} after ${anchor}`;
}

export function formatRelativeTime(dateStr) {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
